interface OptionNotFoundProps {
  optionId: string
}
export function OptionNotFound(props: OptionNotFoundProps) {
  return <h3>Option not found: {props.optionId}</h3>
}
